import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class ReasonCodeData extends EntityData<ReasonCodeData> {
    public static readonly DISCOUNT_TYPE = "DISCOUNT";
    public static readonly PRICE_REDUCTION_TYPE = "PRICE_REDUCTION";
    public static readonly REFUND_TYPE = "REFUND";
    public static readonly REOPEN_TYPE = "REOPEN";
    public static readonly RETURN_TYPE = "RETURN";
    public static readonly VOID_TYPE = "VOID";
    public static readonly WASTAGE_TYPE = "WASTAGE";

    @identifier id: number;
    @field code: string;
    @field codeType: string;
    @field description: string;
    @field requiresComment: boolean;
    @field discontinued: boolean;
}
